import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MvdModalService } from 'app/shared/services/modal/mvd-modal.service';
import { BaseComponent } from '../shared/base-components/base.component';
import { NoteViewModel } from './models/views/note-view.model';
import { AccessControlType } from '../foundation/models/enums/access-control-type.enum';
import { NoteComponent } from './note.component';
import { NoteModalComponent } from './note-modal/note-modal.component';
import { NoteManageService } from './note-manage.service';
import { NoteModelHistoryComponent, NoteHistoryContext } from './note-modal/note-history/note-mode-history.component';
import { ModalSize } from '../shared/services/modal/mvd-modal.enum';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'note-single-view',
    templateUrl: './single-view.html'
})

export class NoteSingleViewComponent extends BaseComponent {

    @Input() isAddOnly = false;
    @Input() isReadonly = false;
    @Input() isDeleteDisabled = false;
    @Input() note: NoteViewModel;
    @Output() noteDeleted = new EventEmitter<number>();
    @Output() noteSaved = new EventEmitter<any>();
    @Input() notes: NoteViewModel[] = new Array<NoteViewModel>();
    @Input() noteIdentificationValue = 0;

    public editNote: NoteViewModel;
    public editMode = false;
    private accessControlType: AccessControlType = new AccessControlType();
    public isOIGFraudNoteClaim = false;
    public notesHistory: NoteViewModel[];
    public isMedicalReviewBU = false;
    public isOIGBU = false;

    constructor(private modalService: MvdModalService, private noteManageService: NoteManageService) {
        super();
    }

    ngOnInit() {
        this.isOIGFraudNoteClaim = this.auth.hasACSTransactionClaimEx(this.auth.acsTransactionClaim, this.accessControlType.LECURestrictions.value) == true;
        if (this.note.id > 0) {
            this.getHistoryNotes(this.note.id);
        }
        this.isMedicalReviewBU = (this.auth.businessUnitId == '6') ? true : false; // 6 - Medical Review Businessunit
        this.isOIGBU = (this.auth.businessUnitId == '1150') ? true : false; // 1150 - OIG Businessunit
    }

    /**
     * edit note
     * */
    toggleEditMode() {
        this.editMode = !this.editMode;

        if (this.editMode) {
            if (this.note.hasOwnProperty('noteIdentificationValue')) {
                let copyNote = new NoteViewModel();
                copyNote.noteIdentificationValue = this.note['noteIdentificationValue'];
                copyNote.noteIdentificationTypeId = this.note['noteIdentificationTypeId'];

                this.editNote = copyNote;
            } else {
                this.editNote = new NoteViewModel();
            }

            this.editNote.id = this.note.id;
            this.editNote.notePriorityTypeID = this.note.notePriorityTypeID;
            this.editNote.noteReceivedTypeID = this.note.noteReceivedTypeID;
            this.editNote.noteShortDescription = this.note.noteShortDescription;
            this.editNote.noteDescription = this.note.noteDescription;
            this.editNote.isConfidential = this.note.isConfidential;
            this.editNote.isOIGFraud = this.note.isOIGFraud;
            this.editNote.isAlert = this.note.isAlert;
            this.editNote.noteDate = this.note.noteDate;
            this.editNote.appendedNoteCount = this.note.appendedNoteCount;
            this.editNote.parentId = this.note.parentId;
            this.editNote.noteIdentificationValue = this.note.noteIdentificationValue;
            this.editNote.noteIdentificationTypeId = this.note.noteIdentificationTypeId;
            this.editNote.rowId = this.note.rowId;
        }
    }

    /**
     * opens model with note history
     * @param note
     */
    public popupNotesHistory(note: NoteViewModel) {
        const data = new NoteHistoryContext(note.id, this.notesHistory);
        this.modalService.open(NoteModelHistoryComponent, data, ModalSize.Medium).afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(
                () => {
                    this.getHistoryNotes(note.id);
                }
            );
    }
    /**
     * Get all note history
     * @param noteId
     */
    public getHistoryNotes(noteId: number) {
        if (noteId != undefined) {
            this.noteManageService.getHistoryNotes(noteId).subscribe(
                result => {
                    this.notesHistory = result;
                },
                e => console.log('error', e)
            );
        }
        return this.notes;
    }

    onNoteSaved(note) {
        this.noteSaved.emit(note);
    }

    onEditCancelled() {
        this.editMode = false;
    }

    // If notes made by Medical Review BU should not be able to be delete unless
    // the user is in the Medical Review BU cc #104112
    // If notes created by OIG bu should be edit/delete only by oig bu CC #113466
    isDeleteEnabled(note: any) {
        return (((note.isOIGFraud && this.isOIGBU) || (note.businessUnitId == 6 && this.isMedicalReviewBU)) || (!note.isOIGFraud && note.businessUnitId != 6));
    }

    deleteNote() {
        if (!this.isDeleteEnabled(this.note)) {
            return;
        }

        this.modalService.confirm()
            .title('Delete Note')
            .body('Are you sure you want to delete this note?')
            .okBtn('Confirm Delete').okBtnFunc(() => this.noteDeleted.emit(this.note.rowId)).cancelBtn('Cancel')
            .open();
    }
}
